import { Component, DOCUMENT, Inject, inject, Renderer2, signal } from '@angular/core';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { environment } from '../../../environments/environment.development';
import { FormControl, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxTurnstileComponent, NgxTurnstileFormsModule } from 'ngx-turnstile';
import { Api } from '../../services/api';
import { catchError, map, of, tap, timeout } from 'rxjs';
import { NgClass, NgStyle } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { Canonical } from '../../services/canonical';

@Component({
  selector: 'app-contacts',
  imports: [
    Navbar,
    Footer,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    NgClass,
    NgxTurnstileComponent,
    NgxTurnstileFormsModule
],
  templateUrl: './contacts.html',
  styleUrl: './contacts.css',
})
export class Contacts {
  title = inject(Title);
  meta = inject(Meta);
  siteKey = environment.turnstileSiteKey;
  isLoading = signal(false);
  isSent = signal(false);
  private api = inject(Api);
  private canonical = inject(Canonical);
  subjects: string[] = ['select-subject', 'general-inquiry', 'partnership-inquiry', 'platform-inquiry', 'career-opportunities', 'other-inquiry'];

  form = new FormGroup({
    firstname: new FormControl('', Validators.required),
    lastname: new FormControl('', Validators.required),
    email: new FormControl('', [
      Validators.required,
      Validators.email
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d+$/),
      Validators.minLength(10),
      Validators.maxLength(11)
    ]),
    subject: new FormControl(this.subjects[0], [Validators.required]),
    message: new FormControl('', [
      Validators.required,
      Validators.maxLength(300)
    ]),
    captchaToken: new FormControl('', Validators.required),
    agree: new FormControl(false, [
      Validators.required,
      Validators.requiredTrue
    ])
  });

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  capitalize(obj?: string) : string | null {
    if(!obj) return null;

      const word = obj
      .toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g,' ')
      .split(' ')
      
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

      const string = word.replace(/\s+/g,' ');
      return string.trim();
  }

  agree(event: Event) : void {
    const element = event.target as HTMLInputElement;
    const isChecked: boolean = element.checked;
    
    this.form.patchValue({
      agree: isChecked
    });
  }

  captchaResponse(token: string | null) : void {
    this.form.patchValue({
      captchaToken: token
    });
  }

  send() : void {
    if(this.form.valid) {
      this.isLoading.set(true);
      this.isSent.set(false);

      this.api.sendMessage({
        firstname: this.form.value?.firstname!,
        lastname: this.form.value?.lastname!,
        email: this.form.value?.email!,
        phone: this.form.value?.phone!,
        subject: this.form.value?.subject!,
        message: this.form.value?.message!,
        captchaToken: this.form.value?.captchaToken!
      })
      .pipe(
        timeout(10000),
        map(() => {
          this.isSent.set(true);
          this.form.reset();
          this.form.patchValue({
            subject: this.subjects[0]
          });
        }),
        catchError(() => of(undefined)),
        tap(() => this.isLoading.set(false))
      ).subscribe();
    }
  }

  private setOrgSchema(obj?: string) : void {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = obj!;
    this.renderer.appendChild(this.document.head, script);
  }

  private initialize() : void {
    this.api.getOptimizeContacts()
    .pipe(
      timeout(10000),
      catchError(() => of({
        canonical: null,
        title: null,
        meta: null,
        org: null
      }))
    ).subscribe(obj => {
      this.canonical.setCanonicalUrl(obj.canonical!);
      this.title.setTitle(obj.title!);
      this.meta.addTags(JSON.parse(obj.meta!));
      this.setOrgSchema(obj.org!);
    });
  }

  ngOnInit() : void {
    this.initialize();
  }
  
}
